"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsNewCustomerProfileDto = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
const LocationDto_1 = require("../locations/LocationDto");
class AnalyticsNewCustomerProfileDto {
    constructor(params) {
        this.locationName = "";
        this.date = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.locationId = params.locationId;
        this.locationName = params.locationName;
        this.date = params.date;
        this.total = params.total;
        if (params.app !== undefined) {
            this.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
        if (params.appVersion !== undefined) {
            this.appVersion = params.appVersion === null ?
                null :
                new AppVersionDto_1.AppVersionDto(params.appVersion);
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.AnalyticsNewCustomerProfileDto = AnalyticsNewCustomerProfileDto;
//# sourceMappingURL=AnalyticsNewCustomerProfileDto.js.map